"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdleMarketService = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const chain_adapters_1 = require("@shapeshiftoss/chain-adapters");
const investor_idle_1 = require("@shapeshiftoss/investor-idle");
const unchained = __importStar(require("@shapeshiftoss/unchained-client"));
const coingecko_1 = require("../coingecko/coingecko");
const bignumber_1 = require("../utils/bignumber");
class IdleMarketService extends coingecko_1.CoinGeckoMarketService {
    constructor({ providerUrls, coinGeckoAPIKey, }) {
        super({ coinGeckoAPIKey });
        this.baseUrl = '';
        this.providerUrls = providerUrls;
        this.idleInvestor = new investor_idle_1.IdleInvestor({
            chainAdapter: new chain_adapters_1.ethereum.ChainAdapter({
                providers: {
                    ws: new unchained.ws.Client(this.providerUrls.unchainedEthereumWsUrl),
                    http: new unchained.ethereum.V1Api(new unchained.ethereum.Configuration({
                        basePath: this.providerUrls.unchainedEthereumHttpUrl,
                    })),
                },
                rpcUrl: this.providerUrls.jsonRpcProviderUrl,
            }),
            providerUrl: this.providerUrls.jsonRpcProviderUrl,
        });
    }
    async findAll() {
        const idleOpportunities = await (async () => {
            const maybeOpportunities = await this.idleInvestor.findAll();
            if (maybeOpportunities.length)
                return maybeOpportunities;
            await this.idleInvestor.initialize();
            return await this.idleInvestor.findAll();
        })();
        const marketDataById = {};
        for (const idleOpportunity of idleOpportunities) {
            const assetId = (0, caip_1.toAssetId)({
                assetNamespace: 'erc20',
                assetReference: idleOpportunity.id,
                chainId: (0, caip_1.fromAssetId)(idleOpportunity.feeAsset.assetId).chainId,
            });
            const coinGeckoData = await super.findByAssetId({
                assetId: idleOpportunity.underlyingAsset.assetId,
            });
            if (!coinGeckoData)
                continue;
            marketDataById[assetId] = {
                price: (0, bignumber_1.bn)(coinGeckoData.price)
                    .times(idleOpportunity.positionAsset.underlyingPerPosition)
                    .toFixed(),
                marketCap: idleOpportunity.tvl.balanceUsdc.toFixed(),
                volume: '0',
                changePercent24Hr: 0,
            };
        }
        return marketDataById;
    }
    async findByAssetId({ assetId }) {
        const opportunity = await (async () => {
            const maybeOpportunities = await this.idleInvestor.findAll();
            if (maybeOpportunities.length)
                return await this.idleInvestor.findByOpportunityId(assetId);
            await this.idleInvestor.initialize();
            return await this.idleInvestor.findByOpportunityId(assetId);
        })();
        if (!opportunity)
            return null;
        const coinGeckoData = await super.findByAssetId({
            assetId: opportunity.underlyingAsset.assetId,
        });
        if (!coinGeckoData)
            return null;
        return {
            price: (0, bignumber_1.bn)(coinGeckoData.price)
                .times(opportunity.positionAsset.underlyingPerPosition)
                .toFixed(),
            marketCap: opportunity.tvl.balanceUsdc.toFixed(),
            volume: '0',
            changePercent24Hr: 0,
        };
    }
    async findPriceHistoryByAssetId() {
        return [];
    }
}
exports.IdleMarketService = IdleMarketService;
